tmVisitorStore = function () {
    return {
        saveDetails: function (name = '', phone = '', email = '', identifier = '') {
            try {
                if (name.length > 0) {
                    Cookies.set('tmv-name', name, { expires: 365, secure: true });
                }
                if (phone.length > 0) {
                    Cookies.set('tmv-phone', phone, { expires: 365, secure: true });
                }
                if (email.length > 0 && tmUtils.validateEmailString(email)) {
                    Cookies.set('tmv-email', email, { expires: 365, secure: true });
                }
                if (identifier.length > 0) {
                    Cookies.set('tmv-identifier', identifier, { expires: 365, secure: true });
                }
            } catch (e) {}
        },

        getDetail: function (what) {
            let returnValue = '';
            try {
                if (what === 'name') {
                    returnValue = Cookies.get('tmv-name') ?? '';
                }
                else if (what === 'phone') {
                    returnValue = Cookies.get('tmv-phone') ?? '';
                }
                else if (what === 'email') {
                    returnValue = Cookies.get('tmv-email') ?? '';
                }
                else if (what === 'identifier') {
                    returnValue = Cookies.get('tmv-identifier') ?? '';
                }
            } catch (e) {}
            return typeof returnValue === 'undefined' ? '' : returnValue
        },

        setAsInternalUser: function () {
            try {
                Cookies.set('tmv-internal-user', 'yes', { expires: 365, secure: true });
            } catch (e) {}
        },

        isInternalUser: function () {
            let returnValue = false;
            try {
                returnValue = Cookies.get('tmv-internal-user') === 'yes';
            } catch (e) {}
            return returnValue;
        },

        setCurrency: function (currencyCode) {
            try {
                Cookies.set('tmv-currency', currencyCode.toUpperCase(), { expires: 365, secure: true });
            } catch (e) {}
        },

        getCurrency: function () {
            let returnValue = 'USD';
            try {
                returnValue = Cookies.get('tmv-currency') ?? returnValue;
            } catch (e) {}
            return typeof returnValue === 'undefined' ? returnValue : returnValue
        },

        isSalesDepartment: function () {
            return this.getLatestOrderRef() === null;
        },

        getLatestOrderRef() {
            let latestOrder = null;
            let orderTags = this.getTags('orders', 1, true, true)
            if (orderTags.length > 0) {
                latestOrder = orderTags[0];
            }
            return latestOrder;
        },

        overrideTagsCookie(tags) {
            try {
                Cookies.set('tmv-tags', tags.join("||"), { expires: 90, secure: true});
            } catch (e) {}
        },

        getTags: function (group = 'all', count = 0, latestFirst = true, removePrefix = false) {
            let tags = [];
            try {
                let currentTagsInCookie = Cookies.get('tmv-tags');
                tags = typeof currentTagsInCookie !== 'undefined' ? currentTagsInCookie.split("||") : []
            } catch (e) {}

            let startsWith = '';
            if (group === 'orders') {
                startsWith = 'or-'
            }
            else if (group === 'products') {
                startsWith = 'p-'
            }
            else if (group === 'checkouts') {
                startsWith = 'ch-'
            }
            if (startsWith.length > 0) {
                tags = tags.filter(function(tag){
                    return tag.startsWith(startsWith);
                })
            }

            if (removePrefix) {
                tags = tags.map(function(tag){
                    return tag.replaceAll('or-', '').replaceAll('p-', '').replaceAll('ch-', '');
                })
            }

            if (latestFirst) {
                tags = tags.reverse();
            }

            if (count > 0) {
                tags = tags.slice(0, count);
            }

            return tags;
        },

        addTag: function (newTag) {
            newTag = newTag.trim();
            if (newTag.length > 0) {
                this.removeTag(newTag); /* remove if exist tag. So added at last - required to maintain sequence.  */
                let currentTags = this.getTags('all', 0, false);
                currentTags.push( newTag );
                this.overrideTagsCookie(currentTags);
            }
        },

        removeTag: function (tag) {
            try {
                let currentTags = this.getTags('all', 0, false);
                let findTagIndex = currentTags.indexOf(tag);
                if (findTagIndex >= 0) {
                    currentTags.splice(findTagIndex, 1);
                    this.overrideTagsCookie(currentTags);
                }
            } catch (e) {}
        },

        getCoolNav: function (latestFirst = true) {
            let coolNav = [];
            try {
                coolNav = JSON.parse(Cookies.get('coolNav') || '[]')
            } catch (e) {}
            if (latestFirst) {
                coolNav = coolNav.reverse();
            }
            return coolNav;
        },

        getViewedProducts: function (restrictTmProductIds = []) {
            let viewedProducts = [];
            let takenProductIds = [];
            let coolNav = this.getCoolNav();
            coolNav.forEach(function(element){
                if(element.type === 'activityDetail' && element.hasOwnProperty('tmActivityId')) {
                    if (!takenProductIds.includes(element.tmActivityId) && (restrictTmProductIds.length === 0 || restrictTmProductIds.includes(parseInt(element.tmActivityId)))) {
                        let data = {
                            tmProductId: element.tmActivityId,
                            blogProductId: null,
                        };
                        if (element.hasOwnProperty('activity') && element.activity !== element.tmActivityId) {
                            data.blogProductId = element.activity;
                        }
                        viewedProducts.push(data);
                        takenProductIds.push(data.tmProductId);
                    }
                }
            });
            return viewedProducts;
        },

        getCurrentTimeHour: function () {
            let now = new Date();
            return now.getHours(); /* 0 - 23 */
        },

        saveSelectedDates: function(startDate, endDate) {
            try {
                if(!startDate && !endDate) {
                    window.localStorage.removeItem('startDate');
                    window.localStorage.removeItem('endDate');
                }
                else {
                    if(!endDate) {
                        window.localStorage.setItem('startDate', startDate);
                        window.localStorage.setItem('endDate', startDate);
                    }
                    else {
                        window.localStorage.setItem('startDate', startDate);
                        window.localStorage.setItem('endDate', endDate);
                    }
                }
                return true;
            }
            catch(error) {
                return false;
            }
        },

        getSavedStartDate: function() {
            let startDate = null;

            try {
                startDate = localStorage.getItem('startDate');
            }
            catch(error) {

            }

            return startDate;
        },

        getSavedEndDate: function() {
            let endDate = null;

            try {
                endDate = localStorage.getItem('endDate');
            }
            catch(error) {

            }

            return endDate;
        },

        setAttributionCookies: function() {
            let ignoreValues = [
                '{src}',
                '{lang}',
                '{currency}',
                '{product_id',
                '{option_id}',
                '{surface}',
                '{funnel}',
                '{GOOGLE-ADS-CLICK-SOURCE}',
            ];

            if (typeof tmBlogRequestJsVars === 'undefined') {
                return;
            }

            let validParameters = tmBlogRequestJsVars.valid_attribution_cookie_parameters || [];

            let parametersToSave = {};

            for (const [key, value] of new URLSearchParams(new URL(window.location.href).search).entries()) {
                if(validParameters.includes(key) && value.trim() !== '' && !ignoreValues.includes(value)) {
                    parametersToSave[key] = value;
                }
            }

            let extractDomainNameFromUrl = function(url){
                let domain;
                //find & remove protocol (http, ftp, etc.) and get domain
                if (url.indexOf("://") > -1) {
                    domain = url.split('/')[2];
                }
                else {
                    domain = url.split('/')[0];
                }
                //find & remove www
                if (domain.indexOf("www.") > -1) {
                    domain = domain.split('www.')[1];
                }

                domain = domain.split(':')[0]; //find & remove port number
                domain = domain.split('?')[0]; //find & remove url params

                return domain;
            }

            let oldCookieParams = Object.fromEntries(new URLSearchParams(Cookies.get('coolAttribution')));

            let newCookieParams = Object.fromEntries(new URLSearchParams(parametersToSave));
            if (document.referrer.length > 0) {
                let referrerDomain = extractDomainNameFromUrl(document.referrer)
                let currentPlainDomain = extractDomainNameFromUrl(window.location.href)
                if (!referrerDomain.includes(currentPlainDomain)) {
                    newCookieParams.http_referrer = referrerDomain
                }
            }

            let cookieParams = Object.assign(oldCookieParams, newCookieParams);

            let cookieParamsAsString = new URLSearchParams(cookieParams).toString();

            Cookies.set('coolAttribution', cookieParamsAsString, { expires: 30, secure: true });
        },

        removeAttributionCookies: function() {
            Cookies.remove('coolAttribution');
        },

        setNavigationCookies: function() {
            if (typeof tmBlogRequestJsVars === 'undefined') {
                return;
            }

            let newItem= tmBlogRequestJsVars.navigation_cookie_data || {};

            if(newItem.type) {
                let navigationItems = [];

                let navigationCookie = Cookies.get('coolNav');

                if(navigationCookie) {
                    navigationItems = JSON.parse(navigationCookie);
                }

                if(navigationItems.length > 20) {
                    navigationItems.shift();
                }

                navigationItems.push(newItem);

                Cookies.set('coolNav', JSON.stringify(navigationItems), { expires: 30, secure: true });
            }
        }
    }
}(window);
